import { Component, OnDestroy, OnInit } from '@angular/core';
import { DebugEvent, DebugEventService } from '../services/debug-event.service';
import { Subscription } from 'rxjs';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NgFor, NgClass, NgIf, JsonPipe } from '@angular/common';
export type debugTypes = "orderList" | "orderDetail" | "patientList" | "crd" | "pas" | "dtr" | "cds" | "pasInquiry" | "providerAccessGroups" |"providerAccessMembers" | "davinciExport";

@Component({
    selector: 'app-debug-container',
    templateUrl: './debug-container.component.html',
    styleUrls: ['./debug-container.component.scss'],
    imports: [NgFor, NgClass, NgIf, JsonPipe]
})
export class DebugContainerComponent implements OnInit, OnDestroy {
  defaultStages: (DebugEvent & { title: string; })[] =
    [{
      title: `Order List Request/Response`,
      request: '',
      response: '',
      type: 'blank',
      category: 'orderList'
    },
    {
      title: `Order Details Request/Response`,
      request: '',
      response: '',
      type: 'blank',
      category: "orderDetail"
    },
    {
      title: `CRD Request/Response`,
      request: '',
      response: '',
      type: 'blank',
      category: "crd"
    },
    {
      title: `DTR Launch`,
      request: '',
      response: '',
      type: 'blank',
      category: "dtr"
    },
    {
      title: `PAS Request/Response`,
      request: '',
      response: '',
      type: 'blank',
      category: "pas"
    },
    {
      title: `PAS Inquiry Request/Response`,
      request: '',
      response: '',
      type: 'blank',
      category: "pasInquiry"
    }];

  stages: (DebugEvent & { title: string; })[] = this.defaultStages;
  alertSubscription: Subscription;

  constructor(
    private debugEventService: DebugEventService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.setStages();
    // subscribe to new alert notifications
    this.alertSubscription = this.debugEventService.onAlert()
      .subscribe(alert => {
        const stageToUpdateIndex = this.stages.findIndex(stage => alert.category === stage.category);
        const stageToUpdate = stageToUpdateIndex >= 0 ? this.stages[stageToUpdateIndex] : null;
        if (stageToUpdate) {
          stageToUpdate.request = alert.request;
          stageToUpdate.response = alert.response;
          stageToUpdate.type = alert.type;
          this.clearSubsequentStages(stageToUpdateIndex);
        }
      });
  }
  ngOnDestroy() {
    // unsubscribe to avoid memory leaks
    this.alertSubscription.unsubscribe();
  }
  clearSubsequentStages(stageToUpdateIndex: number) {
    for (let i = stageToUpdateIndex + 1; i < this.stages.length; i++) {
      this.stages[i].request = "";
      this.stages[i].response = "";
      this.stages[i].type = "blank";
    }
  }
  setStages() {
    // subscribe to router event changes to load correct stages
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && event.url === "/orderlist") {
        this.stages = this.defaultStages;
      }
      if (event instanceof NavigationEnd && event.url === "/patientlist") {
        this.stages = this.patientStages;
      }
      else if (event instanceof NavigationStart && event.url === "/provideraccess") {
        this.stages = this.providerAccessStages;
      }
      if (event instanceof NavigationEnd && event.url === "/error") {
        this.stages = [];
      }
    });
  }

  get patientStages(): (DebugEvent & { title: string; })[] {
    return [{
      title: 'Patients Request / Response',
      request: '',
      response: '',
      type: 'blank',
      category: 'patientList'
    },
    {
      title: `CPG Launch`,
      request: '',
      response: '',
      type: 'blank',
      category: 'cds'
    }];
  }
  
  get providerAccessStages(): (DebugEvent & { title: string; })[] {
    return [{
      title: 'Provider Access Groups',
      request: '',
      response: '',
      type: 'blank',
      category: 'providerAccessGroups'
    },{
      title: 'Provider Access Members',
      request: '',
      response: '',
      type: 'blank',
      category: 'providerAccessMembers'
    },
    {
      title: 'Davinci Export',
      request: '',
      response: '',
      type: 'blank',
      category: 'davinciExport'
    },
  ]
  }
}
